import React from 'react';

interface AdministrationIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const AdministrationIcon: React.FC<AdministrationIconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <g clipRule="evenodd" fill="#B5BCC4" fillRule="evenodd">
        <path d="M9.136 1.839c.26-.23.65-.23.91 0a8.726 8.726 0 0 0 6.18 2.181c.316-.014.6.189.69.492.478 1.627.534 3.33.187 4.957a.686.686 0 1 1-1.342-.287 8.733 8.733 0 0 0-.03-3.78 10.098 10.098 0 0 1-6.14-2.156 10.098 10.098 0 0 1-6.14 2.156 8.725 8.725 0 0 0 6.312 10.404.686.686 0 1 1-.345 1.329A10.098 10.098 0 0 1 2.265 4.512a.686.686 0 0 1 .69-.492 8.725 8.725 0 0 0 6.18-2.181Z" />
        <path d="M13.487 13.307a2.255 2.255 0 1 1 3.189 3.19 2.255 2.255 0 0 1-3.189-3.19Zm1.595.713a.882.882 0 1 0 0 1.764.882.882 0 0 0 0-1.764Z" />
        <path d="M15.082 11.47c.378 0 .686.308.686.687v1.176a.686.686 0 1 1-1.373 0v-1.176c0-.38.307-.687.687-.687ZM15.082 15.784c.378 0 .686.307.686.687v1.176a.686.686 0 1 1-1.373 0v-1.176c0-.38.307-.687.687-.687ZM18.053 13.186a.686.686 0 0 1-.251.938l-1.019.588a.686.686 0 1 1-.686-1.189l1.019-.588a.686.686 0 0 1 .937.251ZM14.318 15.343a.686.686 0 0 1-.251.938l-1.02.588a.686.686 0 0 1-.686-1.189l1.02-.588a.686.686 0 0 1 .937.251ZM12.11 13.186c.19-.328.609-.44.937-.251l1.02.588a.686.686 0 1 1-.686 1.189l-1.02-.588a.686.686 0 0 1-.251-.938ZM15.845 15.343a.686.686 0 0 1 .938-.251l1.02.588a.686.686 0 0 1-.686 1.189l-1.02-.588a.686.686 0 0 1-.252-.938Z" />
      </g>
    </svg>
  );
};
